<template>
  <div class="container-fluid py-3 px-4">
    <div class="border border-1 rounded-3 p-3 mb-3 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-card-heading display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            SEGUIMIENTO DE SOLICITUDES
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            BUSQUEDA DE INFORMACION
          </p>
        </div>
      </div>
    </div>
    <abbr title="LISTADO DE PERSONAL PARA PROGRAMACION EMPO"
      v-if="permisoVisualizador == 10 || permisoVisualizador == 9 || permisoVisualizador == 12">
      <button @click="descargarExcelBienestar" :class="{
        'btn btn border-dark border-1 ms-2 me-1 bg-secondary text-white': !excelBien,
        'btn btn-light border-dark border-1 text-success ms-2': excelBien,
      }" :disabled="!excelBien">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-heart-pulse"
          viewBox="0 0 16 16">
          <path
            d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053.918 3.995.78 5.323 1.508 7H.43c-2.128-5.697 4.165-8.83 7.394-5.857q.09.083.176.171a3 3 0 0 1 .176-.17c3.23-2.974 9.522.159 7.394 5.856h-1.078c.728-1.677.59-3.005.108-3.947C13.486.878 10.4.28 8.717 2.01zM2.212 10h1.315C4.593 11.183 6.05 12.458 8 13.795c1.949-1.337 3.407-2.612 4.473-3.795h1.315c-1.265 1.566-3.14 3.25-5.788 5-2.648-1.75-4.523-3.434-5.788-5" />
          <path
            d="M10.464 3.314a.5.5 0 0 0-.945.049L7.921 8.956 6.464 5.314a.5.5 0 0 0-.88-.091L3.732 8H.5a.5.5 0 0 0 0 1H4a.5.5 0 0 0 .416-.223l1.473-2.209 1.647 4.118a.5.5 0 0 0 .945-.049l1.598-5.593 1.457 3.642A.5.5 0 0 0 12 9h3.5a.5.5 0 0 0 0-1h-3.162z" />
        </svg>
        <b v-if="!excelBien"> Cargando...</b>
      </button>
    </abbr>


    <div class=" border border-1 rounded-3 p-3 mb-3 ">

      <div v-if="!SolicitudCargar" class="d-flex justify-content-end mt-2">
        <span for="" class="input-group-text mt-3 buscar-estiloCuadrado"> <i class="bi bi-search"></i></span>
        <input class="form-control form-control-lg w-25 mt-3 me-2 buscar-estiloCuadrado" type="text"
          aria-label=".form-control-lg example" placeholder="POR SOLICITUD / SCC / ESTADO /ASIGNADO" v-model="busqueda"
          @input="Filtro" />
      </div>

      <div class="table-responsive mx-2 mt-2">

        <div v-if="SolicitudCargar" class="w-full overflow-hidden mx-2 mt-5">
          <b-row class="mt-1">
            <b-col cols="12" class="mt-5">
              <b-skeleton-img no-aspect height="380px"></b-skeleton-img>
            </b-col>
          </b-row>
        </div>

        <div v-if="!SolicitudCargar">
          <table class="table table-bordered" v-if="tabla1">
            <thead class="reducirTamaño">
              <tr class="bg-solimano text-white text-center text-nowrap">
                <th scope="col"><i class="bi bi-boxes"></i></th>
                <th scope="col">N° SOL</th>
                <th scope="col">ESTADO</th>
                <th scope="col">F. REGISTRO</th>
                <th scope="col">ASIGNADO A</th>
                <th scope="col">LUGAR</th>
                <th scope="col">EMPRESA</th>
                <th scope="col">CLIENTE</th>
                <th scope="col">PUESTO</th>
                <th scope="col">CANT.</th>
              </tr>
            </thead>
            <!-- .slice(NUM_RESULTS - 6, NUM_RESULTS) -->

            <tbody v-for="(post, index) in paginatedRespuesta" :key="index">
              <!-- v-if="filter(post)" -->
              <tr class="text-center align-middle reducirTamaño">

                <td scope="row" class="text-center tabla-estiloCompreso">
                  <div class="mx-2" @click="listado(post.idMaeSolicitud)">
                    <button class="btn btn-outline-success boton-estiloCuadrado">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                  </div>
                </td>

                <!-- 🔢 N° SOL -->
                <td class="fw-semibold text-primary text-center">
                  <i class="bi bi-file-earmark-text me-1"></i>
                  {{ post.idMaeSolicitud }}
                </td>

                <!-- 🚦 ESTADO -->
                <td>
                  <span class="fw-semibold text-center label-resaltado" :class="{
                    'text-warning': post.solEstado == '001',
                    'text-muted': post.solEstado == '002',
                    'text-success': post.solEstado == '003',
                    'text-danger': post.solEstado == '004',
                    'text-secondary': post.solEstado == '005'
                  }">
                    <i :class="{
                      'bi bi-hourglass-split': post.solEstado == '001',
                      'bi bi-check-circle': post.solEstado == '003',
                      'bi bi-clock-history': post.solEstado == '002',
                      'bi bi-x-circle': post.solEstado == '004',
                      'bi bi-slash-circle': post.solEstado == '005'
                    }"></i>
                    {{ post.desEstado }}
                  </span>
                </td>

                <!-- 📅 Fecha -->
                <td class="text-center">
                  <i class="bi bi-calendar-check me-1 text-muted"></i>
                  {{ post.solFecRegistro.slice(0, 10) }}
                </td>

                <!-- 👤 Asignado -->
                <td class="text-start">
                  <i class="bi bi-person-workspace me-1 text-secondary"></i>
                  {{ post.responSeleccion || '—' }}
                </td>

                <!-- 📍 Lugar -->
                <td class="text-center">
                  <i class="bi bi-geo-alt-fill me-1 text-danger"></i>
                  {{ post.desUbigeo }}
                </td>

                <!-- 🏢 Empresa -->
                <td class="text-start">
                  <i class="bi bi-building-fill me-1 text-primary"></i>
                  {{ post.centroCosto }}
                </td>

                <!-- 💼 Cliente -->
                <td class="text-start">
                  <i class="bi bi-people me-1 text-info"></i>
                  {{ post.subCentroCosto }}
                </td>

                <!-- 🎯 Puesto -->
                <td class="text-start">
                  <i class="bi bi-person-badge-fill me-1 text-success"></i>
                  {{ post.nomPuesto }}
                </td>

                <!-- 👥 Cantidad -->
                <td class="text-start">
                  <i class="bi bi-123 me-1 text-dark"></i>
                  {{ post.solCanPostulante }}
                </td>
              </tr>
            </tbody>
          </table>

          <!-- tabla2 -->

          <table class="table table-bordered" v-if="!tabla1">
            <thead class="reducirTamaño">
              <tr class="bg-solimano text-white text-center text-nowrap">
                <th scope="col"><i class="bi bi-boxes"></i></th>
                <th scope="col">N° SOL</th>
                <th scope="col">ESTADO</th>
                <th scope="col">F. REGISTRO</th>
                <th scope="col">ASIGNADO A</th>
                <th scope="col">LUGAR</th>
                <th scope="col">EMPRESA</th>
                <th scope="col">CLIENTE</th>
                <th scope="col">PUESTO</th>
                <th scope="col">CANT.</th>
              </tr>
            </thead>
            <!-- .slice(NUM_RESULTS - 6, NUM_RESULTS) -->

            <tbody v-for="(post, index) in paginatedRespuesta" :key="index.id">
              <!-- v-if="filter(post)" -->
              <tr class="text-center align-middle reducirTamaño">
                <td scope="row" class="text-center tabla-estiloCompreso">
                  <div class="mx-2" @click="listado(post.idMaeSolicitud)">
                    <button class="btn btn-outline-success boton-estiloCuadrado">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                  </div>
                </td>

                <td class="fw-semibold text-primary text-center">
                  <i class="bi bi-file-earmark-text me-1"></i>
                  {{ post.idMaeSolicitud }}
                </td>

                <!-- 🔸 Estado con color dinámico -->
                <td class="fw-bold text-uppercase text-star" :class="{
                  'text-warning': post.solEstado == '001',
                  'text-primary': post.solEstado == '002',
                  'text-success': post.solEstado == '003',
                  'text-danger': post.solEstado == '004',
                  'text-secondary': post.solEstado == '005'
                }">
                  <i class="me-1" :class="{
                    'bi bi-hourglass-split': post.solEstado == '001',
                    'bi bi-clock-history': post.solEstado == '002',
                    'bi bi-check-circle-fill': post.solEstado == '003',
                    'bi bi-x-circle-fill': post.solEstado == '004',
                    'bi bi-slash-circle': post.solEstado == '005'
                  }"></i>
                  {{ post.desEstado }}
                </td>

                <!-- 📅 Fecha -->
                <td class="text-muted text-center">
                  <i class="bi bi-calendar-event me-1"></i>
                  {{ post.solFecRegistro.slice(0, 10) }}
                </td>

                <!-- 👤 Asignado -->
                <td class="text-start">
                  <i class="bi bi-person-workspace me-1"></i>
                  {{ post.responSeleccion || '—' }}
                </td>

                <!-- 📍 Lugar -->
                <td class="text-center">
                  <i class="bi bi-geo-alt-fill me-1 text-danger"></i>
                  {{ post.desUbigeo }}
                </td>

                <!-- 🏢 Empresa -->
                <td class="text-start">
                  <i class="bi bi-building-fill me-1 text-primary"></i>
                  {{ post.centroCosto }}
                </td>

                <!-- 🧩 Subcentro -->
                <td class="text-start">
                  <i class="bi bi-people me-1 text-info"></i>
                  {{ post.subCentroCosto }}
                </td>

                <!-- 🎯 Puesto -->
                <td class="text-start">
                  <i class="bi bi-person-badge-fill me-1 text-success"></i>
                  {{ post.nomPuesto }}
                </td>

                <!-- 👥 Cantidad -->
                <td class="text-start">
                  <i class="bi bi-123 me-1"></i>
                  {{ post.solCanPostulante }}
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
        <button class="btn btn-outline-primary btn-sm" @click="pag = 1" :disabled="pag === 1">
          <i class="bi bi-chevron-double-left"></i>
        </button>

        <button class="btn btn-outline-primary btn-sm" @click="pag--" :disabled="pag === 1">
          <i class="bi bi-chevron-left"></i>
        </button>

        <span class="pagination-info small">
          Página {{ pag }} de {{ totalPages1 }}
        </span>

        <button class="btn btn-outline-primary btn-sm" @click="pag++" :disabled="pag === totalPages1">
          <i class="bi bi-chevron-right"></i>
        </button>

        <button class="btn btn-outline-primary btn-sm" @click="pag = totalPages1" :disabled="pag === totalPages1">
          <i class="bi bi-chevron-double-right"></i>
        </button>
      </div>
    </div>

    <div class="border border-1 rounded-3 p-3 mb-3 ">
      <!-- segunda tabla -->

      <div v-if="!SolicitudCargarDet" class="d-flex justify-content-end mt-2">
        <span for="" class="input-group-text mt-3 buscar-estiloCuadrado"> <i class="bi bi-search"></i></span>
        <input class="form-control form-control-lg w-25 mt-3 me-2 buscar-estiloCuadrado" type="text"
          aria-label=".form-control-lg example" placeholder="POR IDENTIDAD / APELLIDOS / NOMBRES" v-model="busqueda2"
          @input="Filtro2" />
      </div>

      <div class="table-responsive mx-2 mt-2">

        <div v-if="SolicitudCargarDet" class="w-full overflow-hidden mx-2 mt-5">
          <b-row class="mt-1">
            <b-col cols="12" class="mt-5">
              <b-skeleton-img no-aspect height="380px"></b-skeleton-img>
            </b-col>
          </b-row>
        </div>

        <div v-if="!SolicitudCargarDet">
          <table v-if="tabla2" class="table table-bordered">
            <thead class="reducirTamaño">
              <tr class="bg-solimano text-white text-center text-nowrap">
                <th scope="col"><i class="bi bi-boxes"></i></th>
                <th scope="col">N° SOL</th>
                <th scope="col">ESTADO</th>
                <th scope="col">F. SELECCION</th>
                <th scope="col">D. IDENTIDAD</th>
                <th scope="col">APELLIDOS Y NOMBRES</th>
                <th scope="col">EMPRESA</th>
                <th scope="col">CLIENTE</th>
                <th scope="col">PUESTO</th>
                <th scope="col">ADJUNTO</th>
              </tr>
            </thead>
            <!-- .slice(NUM_RESULTS1 - 6, NUM_RESULTS1) -->
            <tbody v-for="(post, index) in paginatedRespuesta2" :key="index.id">
              <!-- v-if="filter(post)" -->
              <tr class="text-center align-middle reducirTamaño">

                <th scope="row" class="text-center tabla-estiloCompreso">
                  <div class="mx-2" @click="
                    listadoPostulante(post.idSolicitud, post.idPostulante)
                    ">
                    <button class="btn btn-outline-success boton-estiloCuadrado">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                  </div>
                </th>

                <td class="fw-semibold text-primary">
                  <i class="bi bi-file-earmark-text me-1"></i>
                  {{ post.idSolicitud }}
                </td>

                <!-- 🚦 Estado con ícono dinámico -->
                <td :class="{
                  'text-success label-resaltado': post.codEstado == '001',  // En proceso
                  'text-danger label-resaltado': post.codEstado == '002',   // Rechazado
                  'text-warning label-resaltado': post.codEstado == '003',  // Pendiente
                }">
                  <i class="me-1" :class="{
                    'bi bi-arrow-repeat': post.codEstado == '001',       // En proceso
                    'bi bi-x-circle-fill': post.codEstado == '002',      // Rechazado
                    'bi bi-hourglass-split': post.codEstado == '003',    // Pendiente
                  }"></i>
                  {{ post.posEstado }}
                </td>

                <!-- 📅 Fecha de selección -->
                <td>
                  <i class="bi bi-calendar-check text-muted me-1"></i>
                  {{ post.fechaSel.slice(0, 10) }}
                </td>

                <!-- 🆔 Número de documento -->
                <td>
                  <i class="bi bi-person-vcard me-1 text-secondary"></i>
                  {{ post.nroDocumento }}
                </td>

                <!-- 👤 Nombre -->
                <td class="text-start">
                  <i class="bi bi-person-fill me-1 text-success"></i>
                  {{ post.nombre }}
                </td>

                <!-- 🏢 Centro de costos -->
                <td class="text-start">
                  <i class="bi bi-building-fill me-1 text-primary"></i>
                  {{ post.nomCentroCostos }}
                </td>

                <!-- 💼 Subcentro de costos -->
                <td class="text-start">
                  <i class="bi bi-people me-1 text-info"></i>
                  {{ post.nomSubCc }}
                </td>

                <!-- 🎯 Puesto -->
                <td class="text-start">
                  <i class="bi bi-person-badge-fill me-1 text-success"></i>
                  {{ post.nomPuesto }}
                </td>
                <!-- {{ post.adjunto }}      -->
                <!-- {{ post.adjunto.slice(45, post.adjunto.legth) }} -->
                <td v-if="post.adjunto != 1" class="text-center">
                  <a :href="url + post.adjunto.slice(45, post.adjunto.legth)" target="_blank">
                    <i class="bi bi-download"></i></a>
                </td>

                <td class="text-center" v-if="post.adjunto == 1">-</td>
              </tr>
            </tbody>
          </table>

          <table v-if="!tabla2" class="table table-bordered">
            <thead class="reducirTamaño">
              <tr class="bg-solimano text-white text-center text-nowrap">
                <th scope="col"><i class="bi bi-boxes"></i></th>
                <th scope="col">N° SOL</th>
                <th scope="col">ESTADO</th>
                <th scope="col">F. SELECCION</th>
                <th scope="col">D. IDENTIDAD</th>
                <th scope="col">APELLIDOS Y NOMBRES</th>
                <th scope="col">EMPRESA</th>
                <th scope="col">CLIENTE</th>
                <th scope="col">PUESTO</th>
                <th scope="col">ADJUNTO</th>
              </tr>
            </thead>
            <!-- .slice(NUM_RESULTS1 - 6, NUM_RESULTS1) -->
            <tbody v-for="(post, index) in paginatedRespuesta2" :key="index.id">
              <!-- v-if="filter(post)" -->
              <tr class="text-center align-middle reducirTamaño">
                <th scope="row" class="text-center tabla-estiloCompreso">
                  <div class="mx-2" @click="
                    listadoPostulante(post.idSolicitud, post.idPostulante)
                    ">
                    <button class="btn btn-outline-success boton-estiloCuadrado">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                  </div>
                </th>

                <td class="fw-semibold text-primary">
                  <i class="bi bi-file-earmark-text me-1"></i>
                  {{ post.idSolicitud }}
                </td>

                <!-- 🚦 Estado con ícono dinámico y color -->
                <td :class="{
                  'text-success label-resaltado': post.codEstado == '001',  // En proceso
                  'text-danger label-resaltado': post.codEstado == '002',   // Rechazado
                  'text-warning label-resaltado': post.codEstado == '003',  // Pendiente
                }">
                  <i class="me-1" :class="{
                    'bi bi-arrow-repeat': post.codEstado == '001',       // En proceso
                    'bi bi-x-circle-fill': post.codEstado == '002',      // Rechazado
                    'bi bi-hourglass-split': post.codEstado == '003',    // Pendiente
                  }"></i>
                  {{ post.posEstado }}
                </td>

                <!-- 📅 Fecha de selección -->
                <td>
                  <i class="bi bi-calendar-event text-muted me-1"></i>
                  {{ post.fechaSel.slice(0, 10) }}
                </td>

                <!-- 🆔 Número de documento -->
                <td>
                  <i class="bi bi-person-vcard me-1 text-secondary"></i>
                  {{ post.nroDocumento }}
                </td>

                <!-- 👤 Nombre del postulante -->
                <td class="text-start">
                  <i class="bi bi-person-fill me-1 text-success"></i>
                  {{ post.nombre }}
                </td>

                <!-- 🏢 Centro de costos -->
                <td class="text-start">
                  <i class="bi bi-building-fill me-1 text-primary"></i>
                  {{ post.nomCentroCostos }}
                </td>

                <!-- 💼 Subcentro de costos -->
                <td class="text-start">
                  <i class="bi bi-people me-1 text-info"></i>
                  {{ post.nomSubCc }}
                </td>

                <!-- 🎯 Puesto -->
                <td class="text-start">
                  <i class="bi bi-person-badge-fill me-1 text-success"></i>
                  {{ post.nomPuesto }}
                </td>
                <!-- {{ post.adjunto }}      -->
                <!-- {{ post.adjunto.slice(45, post.adjunto.legth) }} -->
                <td v-if="post.adjunto != 1" class="text-center">
                  <a :href="url + post.adjunto.slice(45, post.adjunto.legth)" target="_blank">
                    <i class="bi bi-download"></i></a>
                </td>

                <td class="text-center" v-if="post.adjunto == 1">-</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
        <!-- Ir a la primera página -->
        <button class="btn btn-outline-primary btn-sm" @click="pags = 1" :disabled="pags === 1">
          <i class="bi bi-chevron-double-left"></i>
        </button>

        <!-- Retroceder -->
        <button class="btn btn-outline-primary btn-sm" @click="pags--" :disabled="pags === 1">
          <i class="bi bi-chevron-left"></i>
        </button>

        <!-- Texto -->
        <span class="pagination-info small">
          Página {{ pags }} de {{ totalPages2 }}
        </span>

        <!-- Avanzar -->
        <button class="btn btn-outline-primary btn-sm" @click="pags++" :disabled="pags === totalPages2">
          <i class="bi bi-chevron-right"></i>
        </button>

        <!-- Ir a la última página -->
        <button class="btn btn-outline-primary btn-sm" @click="pags = totalPages2" :disabled="pags === totalPages2">
          <i class="bi bi-chevron-double-right"></i>
        </button>
      </div>
    </div>
  </div>

  <!--  poner flitro en la primera de solicitud con  n°Sol ,Asignado, lugar,Puesto, Scc
  segunda tabla por numero de documento, nombre,scc y puesto

  adjunto flechita descargable
-->
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SolimanologGestionarContrato",

  data() {
    return {
      url: "https://apitopas.gruposolimano.com.pe/Documentos/CV/",
      excel: "",
      filterField: "",
      filterField1: "",
      cerrarTable1: true,
      adams: false,
      NUM_RESULTS: 8,   // tamaño de página tabla1
      NUM_RESULTS1: 8,  // tamaño de página tabla2
      pag: 1,           // página actual tabla1
      pags: 1,          // página actual tabla
      excelBien: false,
      noAvanzar: false,
      noRetroceder: false,
      noAvanzar1: false,
      noRetroceder1: false,
      permisoVisualizador: null,
      trabajador: null,
      Respuesta: [],
      busqueda: "",
      tabla1: true,
      Respuesta2: [],
      busqueda2: "",
      tabla2: true,
    };
  },

  mounted() {
    this.permisoVisualizador = localStorage.getItem("idPerfil");
    this.trabajador = localStorage.getItem("idTrabajdor");
  },


  created() {
    if (localStorage.getItem("idPerfil") == 10 || localStorage.getItem("idPerfil") == 9 || localStorage.getItem("idPerfil") == 12) {
      this.reporteBienestar();
    }

    // if (localStorage.getItem("idPerfil") == 6) {
    //   this.reporte();
    // }

    if (localStorage.getItem("idPerfil") == 9 || localStorage.getItem("idPerfil") == 12) {
      this.reporteSST();
    }

    this.cambiarEstadoNavbar();



  },

  computed: {
    ...mapGetters("solicitudesListado", ["Solicitud", "Solicitudes", "SolicitudCargarDet", "SolicitudCargar"]),
    totalPages1() {
      const baseData = this.tabla1 ? this.Solicitud : this.Respuesta;
      return Math.ceil(baseData.length / this.NUM_RESULTS);
    },
    paginatedRespuesta() {
      const baseData = this.tabla1 ? this.Solicitud : this.Respuesta;
      const start = (this.pag - 1) * this.NUM_RESULTS;
      return baseData.slice(start, start + this.NUM_RESULTS);
    },

    // Tabla 2
    totalPages2() {
      const baseData = this.tabla2 ? this.Solicitudes : this.Respuesta2;
      return Math.ceil(baseData.length / this.NUM_RESULTS1);
    },
    paginatedRespuesta2() {
      const baseData = this.tabla2 ? this.Solicitudes : this.Respuesta2;
      const start = (this.pags - 1) * this.NUM_RESULTS1;
      return baseData.slice(start, start + this.NUM_RESULTS1);
    },
  },

  methods: {

    reporteBienestar() {
      this.excelBien = false;
      this.axios
        .get("ReportesExcel/ReporteBienestar", { responseType: "blob" })
        .then((response) => {
          this.excelBien = true;
          this.excelBienestar = response.data;
          console.log(response.data);
        });
    },

    reporteSST() {
      this.excelBien = false;
      this.axios
        .get(`ReportesExcel/ReportePosCapacitados`, { responseType: "blob" })
        .then((r) => {
          this.excelSst = true;
          this.excelSstDocumento = r.data;
          console.log(r.data);
        });
    },

    descargarExcelBienestar() {
      var fileURL = window.URL.createObjectURL(new Blob([this.excelBienestar]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "ReporteBienestar.xlsx");
      document.body.appendChild(fileLink);

      fileLink.click();
    },

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    Filtro() {
      if (this.busqueda.length > 0) {
        this.tabla1 = false;
        this.Respuesta = [];

        const currentDni = this.busqueda; // Captura el valor actual de busqueda

        this.axios
          .get(
            `AccesoSolicitud/BusquedaSolicitud?idTrabajador=${this.trabajador}&busqueda=${currentDni}`
          )
          .then((response) => {
            // Verifica que el valor actual de busqueda sea igual al valor al que correspondía la respuesta
            if (currentDni === this.busqueda) {
              this.Respuesta = response.data;
              console.log(response.data);
              this.pag = 1;
            }
          })
          .catch((error) => {
            // Manejo de errores si es necesario
            console.log(error);
          });
      } else {
        this.tabla1 = true;
        this.pag = 1;
      }
    },

    Filtro2() {
      if (this.busqueda2.length > 0) {
        this.tabla2 = false;
        this.Respuesta2 = [];

        const currentDni = this.busqueda2; // Captura el valor actual de busqueda

        this.axios
          .get(
            `SolicitudPostulante/BusquedaPostulanteDetx?idTrabajador=${this.trabajador}&busqueda=${this.busqueda2}`
          )
          .then((response) => {
            // Verifica que el valor actual de busqueda sea igual al valor al que correspondía la respuesta
            if (currentDni === this.busqueda2) {
              this.Respuesta2 = response.data;
              console.log(response.data);
              this.pags = 1;
            }
          })
          .catch((error) => {
            // Manejo de errores si es necesario
            console.log(error);
          });
      } else {
        this.tabla2 = true;
        this.pags = 1;
      }
    },


    regresar() {
      this.$router.push("/Dashboard");
    },
    listadoPostulantes() {
      this.$router.push("/listadosSolicitud");
    },
    seguimientoSolicitud() {
      this.$router.push("/seguimientoDeSolicitud");
    },
    nuevosIntegrantes() {
      this.$router.push("/contratosNuevosIntegrantes");
    },





    listado(id) {
      console.log(id);
      this.$router.push("/seguimientoSolcitudContra/" + id);
    },
    listadoSolic() {
      this.$router.push("/listadoDni");
    },

    listadoPostulante(id, usuario) {
      localStorage.setItem("solicitudXpostulante", usuario);
      this.$router.push("gestionSolicitudXsolContra/" + id);
    },



    retroceso() {
      if (this.NUM_RESULTS === 6) {
        this.noRetroceder = true;
      } else {
        this.NUM_RESULTS -= 6;
        this.pag -= 1;
        this.noAvanzar = false;
        this.noRetroceder = false;
      }
    },

    retroceso1() {
      if (this.NUM_RESULTS1 === 6) {
        this.noRetroceder1 = true;
      } else {
        this.NUM_RESULTS1 -= 6;
        this.pags -= 1;
        this.noAvanzar1 = false;
        this.noRetroceder1 = false;
      }
    },
    aumentar() {
      this.NUM_RESULTS += 6;
      this.pag += 1;
      if (this.NUM_RESULTS > 6) {
        this.noRetroceder = false;
      } else {
        this.noRetroceder = true;
      }
      if (this.NUM_RESULTS > this.Solicitud.length) {
        this.noAvanzar = true;
      }
    },
    aumentar1() {
      this.NUM_RESULTS1 += 6;
      this.pags += 1;
      if (this.NUM_RESULTS1 > 6) {
        this.noRetroceder1 = false;
      } else {
        this.noRetroceder1 = true;
      }
      if (this.NUM_RESULTS1 > this.Solicitud.length) {
        this.noAvanzar1 = true;
      }

      // console.log(this.NUM_RESULTS);
    },
  },
};
</script>

<style scoped>
.reducirTamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #1565C0;
}

.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.boton-estiloPag {
  border: 1px solid rgb(199, 199, 199);
  background-color: white;
  color: rgb(32, 32, 32);
  padding: 0.6rem 1rem;
  border-radius: 0;
}

.boton-estiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
  /* Cambia el cursor a una mano */
}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}

.label-resaltado {
  font-weight: 700;
  font-size: 0.65rem;
}
</style>
